<template functional>
  <component
    :is="injections.components[props.aside.component]"
    v-bind="data.attrs"
    v-on="listeners"
  />
</template>

<script>
import AsideStatsSection from '@/components/sidebar/sections/AsideStatsSection.vue';
import AsideMyTeamSection from '@/components/sidebar/sections/AsideMyTeamSection.vue';
import AsideMyScoreSection from '@/components/sidebar/sections/AsideMyScoreSection.vue';
import AsideCommentsSection from '@/components/sidebar/sections/AsideCommentsSection.vue';
import AsideSettingsSection from '@/components/sidebar/sections/AsideSettingsSection.vue';
import AsideLeaderBoardSection from '@/components/sidebar/sections/AsideLeaderBoardSection.vue';

export default {
  inject: {
    components: {
      default: {
        AsideStatsSection,
        AsideMyTeamSection,
        AsideMyScoreSection,
        AsideCommentsSection,
        AsideSettingsSection,
        AsideLeaderBoardSection,
      }
    },
  }
}
</script>
